'use client';

import { Link, Stack, Typography } from '@mui/material';

import { Iconify, APP_ICONS } from 'src/components/iconify';

import { PolicyTabLoyout } from '../../components/policy-tab-layout';

export const TermView = () => (
  <PolicyTabLoyout>
    <Stack spacing={3}>
      <Stack>
        <Typography variant="h4">ĐIỀU KHOẢN DỊCH VỤ</Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Khi bạn truy cập và sử dụng trang web centerup.vn, bạn phải đồng ý tuân thủ các điều khoản
          và điều kiện được mô tả dưới đây. Chúng tôi, Công ty Cổ phần Ant Learning Vietnam được
          thành lập theo quy định của Luật Doanh nghiệp năm 2015 tại Việt Nam. Có trụ sở: Số nhà 8,
          Ngõ 59, đường Láng Hạ, Phường Thành Công, Quận Ba Đình, Thành phố Hà Nội, Việt Nam.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Chúng tôi có quyền cập nhật và thay đổi Điều khoản dịch vụ mà không cần thông báo trước.
          Mọi tính năng mới được cung cấp nhằm tăng cường và nâng cao Dịch vụ hiện tại, bao gồm cả
          việc phát hành các công cụ và tài nguyên mới đều phải tuân theo Điều khoản dịch vụ. Việc
          tiếp tục sử dụng Dịch vụ sau bất kỳ thay đổi nào như vậy sẽ được coi là sự đồng ý của bạn
          đối với những thay đổi này. Bạn có thể xem lại phiên bản mới nhất của Điều khoản dịch vụ
          bất cứ lúc nào tại trang Điều khoản dịch vụ trên trang web centerup.vn.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Việc sử dụng dịch vụ của bạn phải tuân theo các điều khoản này. Nếu bạn vi phạm bất kỳ
          điều khoản nào, chúng tôi sẽ tạm ngừng hoặc chấm dứt vĩnh viễn quyền truy cập dịch vụ của
          bạn.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Mặc dù chúng tôi nỗ lực để giám sát nội dung và hành vi của bạn, nhưng bạn vẫn có thể tự
          chịu trách nhiệm cho những tương tác và nội dung mà bạn gặp phải khi sử dụng dịch vụ.
          Chúng tôi khuyến khích bạn báo cáo bất kỳ hành vi vi phạm nào mà bạn gặp phải để chúng tôi
          có thể thực hiện biện pháp xử lý thích hợp.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Việc sử dụng dịch vụ của bạn đồng nghĩa với việc bạn đồng ý tự chịu rủi ro. Chúng tôi
          không chịu trách nhiệm cho bất kỳ thiệt hại nào phát sinh từ việc sử dụng Dịch vụ của bạn.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2" fontWeight={700}>
          ĐIỀU KHOẢN CƠ BẢN
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Nếu bạn không đồng ý, tốt nhất bạn nên từ chối thỏa thuận này và ngừng sử dụng Dịch vụ
          ngay lập tức. Quyền truy cập vào Dịch vụ chỉ được cấp cho những người hoàn toàn đồng ý với
          các điều khoản và điều kiện của thỏa thuận dịch vụ này.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Bạn đồng ý các điều khoản thỏa thuận dịch vụ này và mối quan hệ giữa các bên sẽ được điều
          chỉnh độc quyền bởi luật pháp của nước Cộng hòa Xã hội Chủ nghĩa Việt Nam và không có liên
          quan đến xung đột với nguyên tắc pháp luật hoặc các hiệp định quốc tế. Thẩm quyền duy nhất
          để giải quyết bất kỳ tranh chấp nào là tòa án tối cao tại thành phố Hà Nội, Việt Nam.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Để hoàn tất quá trình đăng ký, bạn cần cung cấp đầy đủ họ tên hợp pháp, địa chỉ email hợp
          lệ và bất kỳ thông tin khác yêu cầu trong quy trình đăng ký.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Thông tin đăng nhập của bạn chỉ được sử dụng bởi một người duy nhất và chỉ được đăng nhập
          một lần. Việc chia sẻ thông tin đăng nhập với nhiều người là không được phép. Tuy nhiên,
          tùy thuộc vào gói dịch vụ bạn chọn, bạn có thể tạo thông tin đăng nhập riêng cho nhiều
          người nếu gói dịch vụ cho phép điều đó.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Duy trì bảo mật tài khoản và mật khẩu là trách nhiệm của cá nhân bạn. Chúng tôi sẽ không
          chịu trách nhiệm về bất kỳ tổn thất hoặc thiệt hại nào phát sinh từ việc bạn nếu bạn không
          tuân thủ nghĩa vụ bảo mật này.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Bạn phải cam kết duy trì tính bảo mật đầy đủ đối với mật khẩu của mình; liên quan đến dịch
          vụ và tài khoản của bạn. Điều này yêu cầu bạn phải duy trì tính bảo mật của mật khẩu và
          thông báo ngay lập tức cho chúng tôi nếu bạn biết về bất kỳ việc sử dụng trái phép nào
          liên quan đến mật khẩu hoặc tài khoản của mình trên trang website centerup.vn.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Với tư cách là chủ sở hữu tài khoản, bạn có trách nhiệm toàn bộ về nội dung được đăng và
          các hoạt động diễn ra bên trong tài khoản của bạn, bao gồm cả việc người dùng khác sử dụng
          tài khoản của bạn để đăng nội dung.
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          Bạn không được phép sử dụng Dịch vụ cho bất kỳ mục đích bất hợp pháp hoặc trái phép nào.
          Trong quá trình sử dụng Dịch vụ, bạn cần cam kết không vi phạm bất kỳ luật nào trong phạm
          vi quyền hạn của mình (bao gồm nhưng không giới hạn ở luật bản quyền). Bạn phải cam kết
          không gây quấy rối, đe dọa, lạm dụng hoặc gây tổn hại cho chúng tôi hoặc các người dùng
          khác của Dịch vụ theo bất kỳ cách nào.
        </Typography>
      </Stack>
      <Typography variant="body2" fontWeight={700}>
        HUỶ BỎ VÀ CHẤM DỨT
      </Typography>
      <Typography variant="body2">
        Bạn sẽ phải chịu toàn bộ trách nhiệm về việc hủy đúng cách tài khoản của mình. Nếu không
        chắc chắn, bạn có thể liên hệ đến bộ phận hỗ trợ tại centerup.vn để hủy tài khoản đúng quy
        trình.
      </Typography>
      <Typography variant="body2">
        Tất cả các nội dung của bạn sẽ bị xóa ngay lập tức khỏi dịch vụ ngay sau khi bạn thực hiện
        thao tác hủy. Các thông tin sẽ không thể khôi phục lại sau khi tài khoản của bạn bị hủy.
      </Typography>
      <Typography variant="body2">
        Nếu bạn chọn hủy bỏ dịch vụ trước khi kỳ thanh toán hiện tại kết thúc, việc hủy bỏ sẽ có
        hiệu lực ngay lập tức và bạn sẽ không bị tính phí lại.
      </Typography>
      <Typography variant="body2">
        Chúng tôi có quyền đình chỉ hoặc chấm dứt tài khoản của bạn và từ chối mọi hình thức sử dụng
        dịch vụ hiện tại hoặc tương lai vì bất kỳ lý do nào, bất cứ lúc nào. Việc chấm dứt dịch vụ
        như vậy sẽ dẫn đến việc vô hiệu hóa hoặc xóa tài khoản của bạn, mất quyền truy cập vào tài
        khoản cũng như việc tịch thu và từ bỏ tất cả nội dung trong tài khoản.
      </Typography>
      <Typography variant="body2">
        Chúng tôi có quyền từ chối cung cấp dịch vụ cho bất kỳ ai với bất kỳ lý do nào và vào bất kỳ
        thời điểm nào.
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        ĐIỀU KHOẢN SỬA ĐỔI
      </Typography>
      <Typography variant="body2">
        Chúng tôi có quyền thay đổi hoặc chấm dứt Dịch vụ (hoặc một phần của Dịch vụ) tạm thời hoặc
        vĩnh viễn, có hoặc không có thông báo trước.
      </Typography>
      <Typography variant="body2">
        Giá của tất cả các Dịch vụ, bao gồm nhưng không giới hạn ở phí gói đăng ký hàng năm cho Dịch
        vụ, có thể thay đổi sau khi chúng tôi thông báo trước ít nhất 30 ngày. Thông báo về các thay
        đổi này có thể được cung cấp bất cứ lúc nào bằng cách đăng thông tin về những thay đổi trên
        Trang web{' '}
        <Link href="https://centerup.vn" target="_blank" rel="noopener">
          CenterUp
        </Link>{' '}
        hoặc trực tiếp thông qua Dịch vụ chính.
      </Typography>
      <Typography variant="body2">
        Chúng tôi không chịu trách nhiệm đối với bạn hoặc bất kỳ bên thứ ba nào về bất kỳ sự thay
        đổi nào, bao gồm sự thay đổi giá, đình chỉ hoặc ngừng cung cấp dịch vụ.
      </Typography>
      <Typography variant="body2">
        Bạn đồng ý rằng hình thức và bản chất của dịch vụ có thể thay đổi theo thời gian mà không
        cần thông báo trước cho Khách hàng, do chúng tôi liên tục tiến hành cải thiện và đổi mới
        dịch vụ. Hơn nữa, bạn thừa nhận và đồng ý rằng chúng tôi có thể ngừng cung cấp Dịch vụ (hoặc
        bất kỳ tính năng nào trong Dịch vụ) cho bạn vĩnh viễn hoặc tạm thời, theo quyết định riêng
        của húng tôi mà không cần thông báo trước cho Khách hàng.
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        ĐIỀU KHOẢN SỬA ĐỔI
      </Typography>
      <Typography variant="body2">
        Nội dung được cung cấp bởi chúng tôi được bảo vệ bởi quyền sở hữu trí tuệ. Bạn không được
        sao chép, phân phối, sửa đổi, cho thuê, cho mượn, cấp phép, tạo ra các tác phẩm phái sinh,
        thực hiện kỹ thuật đảo ngược, dịch ngược hoặc cố gắng trích xuất mã nguồn của dịch vụ hoặc
        bất kỳ phần nào của dịch vụ mà không có sự cho phép tương ứng từ chúng tôi.
      </Typography>
      <Typography variant="body2">
        Chúng tôi không sở hữu quyền trí tuệ đối với tài liệu do bạn cung cấp cho dịch vụ. Hồ sơ và
        tài liệu của bạn, khi tải lên, vẫn thuộc quyền sở hữu của bạn. Tuy nhiên, khi bạn chia sẻ
        các trang của bạn công khai cũng đồng nghĩa với việc bạn đồng ý cho phép người khác xem và
        chia sẻ nội dung của bạn.
      </Typography>
      <Typography variant="body2">
        Chúng tôi không tiến hành sàng lọc trước nội dung, tuy nhiên, chúng tôi và các đại diện được
        chỉ định có quyền (nhưng không có nghĩa vụ) từ chối hoặc xóa bất kỳ nội dung nào có sẵn
        thông qua dịch vụ, theo quyết định riêng của họ.
      </Typography>
      <Typography variant="body2">
        Bạn cam kết không tạo, truyền tải, hiển thị hoặc cung cấp bất kỳ nội dung nào vi phạm pháp
        luật, gây hại, đe dọa, lạm dụng, quấy rối, xúc phạm, phỉ báng, thô tục, tục tĩu, xâm phạm
        quyền riêng tư của người khác hoặc chứa nội dung gây hận thù (bao gồm cả vi-rút, sâu và bất
        kỳ mã độc hại nào khác).
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        ĐIỀU KIỆN CHUNG
      </Typography>
      <Typography variant="body2">
        Việc sử dụng Dịch vụ là một rủi ro duy nhất mà bạn phải chấp nhận. Dịch vụ được cung cấp
        theo nguyên tắc “như là’’ và “có sẵn’’.
      </Typography>
      <Typography variant="body2">Chúng tôi (nhà cung cấp dịch vụ) không đảm bảo rằng:</Typography>
      <Stack ml={2} spacing={0.5}>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Việc sử dụng dịch vụ sẽ đáp ứng đầy đủ các yêu cầu của bạn.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Việc sử dụng dịch vụ sẽ không bị gián đoạn, được thực hiện kịp thời, an toàn và không có
            lỗi.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Mọi thông tin bạn thu được từ việc sử dụng dịch vụ sẽ chính xác, đáng tin cậy và được
            cập nhật.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Các lỗi trong hoạt động hoặc chức năng của dịch vụ sẽ được sửa chữa.
          </Typography>
        </Stack>
      </Stack>
      <Typography variant="body2">
        Chúng tôi cung cấp hỗ trợ kỹ thuật có sẵn thông qua email để giải quyết các vấn đề và các
        câu hỏi của bạn.
      </Typography>
      <Typography variant="body2">
        Chúng tôi không cung cấp bảo hành, bao gồm cả chất lượng phù hợp, tính phù hợp cho mục đích
        cụ thể hoặc phù hợp với mô tả, trừ khi có quy định rõ ràng trong Thỏa thuận.
      </Typography>
      <Typography variant="body2">
        Việc sử dụng Dịch vụ là một rủi ro duy nhất mà bạn phải chấp nhận. Dịch vụ được cung cấp
        theo nguyên tắc “như là’’ và “có sẵn’’.
      </Typography>
      <Typography>
        Chúng tôi không chịu trách nhiệm đối với bất kỳ thiệt hại trực tiếp, gián tiếp hoặc phát
        sinh sau này (bao gồm mất lợi nhuận, mất dữ liệu, mất thiện chí hoặc uy tín kinh doanh) mà
        bạn có thể gán cho dịch vụ, bao gồm:
      </Typography>
      <Stack ml={2} spacing={0.5}>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Thiệt hại do bất kỳ thay đổi nào mà chúng tôi có thể thực hiện đối với dịch vụ.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Thiệt hại do bất kỳ sự gián đoạn vĩnh viễn hoặc tạm thời nào trong việc cung cấp dịch
            vụ.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Thiệt hại do xóa, thay đổi hoặc không lưu trữ bất kỳ nội dung nào của bạn.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Thiệt hại do bạn không cung cấp cho chúng tôi thông tin tài khoản chính xác.
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="start">
          <Iconify icon={APP_ICONS.status.dot} />
          <Typography variant="body2">
            Thiệt hại do việc bạn không bảo mật mật khẩu hoặc chi tiết tài khoản của mình.
          </Typography>
        </Stack>
      </Stack>
      <Typography variant="body2">
        Bạn không được phép sửa đổi, điều chỉnh hoặc xâm nhập vào Dịch vụ; cũng như không được sửa
        đổi một trang web khác để tạo ra sự ngụ ý sai rằng nó có liên kết với Dịch vụ.
      </Typography>
      <Typography variant="body2">
        Bạn hiểu rằng chúng tôi sử dụng các nhà cung cấp bên thứ ba và đối tác lưu trữ để cung cấp
        phần cứng, phần mềm, mạng, lưu trữ và công nghệ liên quan cần thiết để vận hành Dịch vụ.
      </Typography>
      <Typography variant="body2">
        Bạn phải chịu trách nhiệm bồi thường cho chúng tôi, các cán bộ, giám đốc, nhân viên, đại lý,
        người cấp phép, nhà cung cấp và các bên liên quan khác đối với mọi khiếu nại, trách nhiệm
        pháp lý, tổn thất, chi phí, thiệt hại và khoản phí phát sinh, bao gồm cả các khoản phí luật
        sư, do vi phạm thỏa thuận hoặc hành vi trên tài khoản của bạn.
      </Typography>
      <Typography variant="body2">
        Chúng tôi có quyền nhưng không có nghĩa vụ xóa nội dung và tài khoản chứa nội dung mà chúng
        tôi xác định một cách riêng là bất hợp pháp, xúc phạm, đe dọa, bôi nhọ, phỉ báng, khiêu dâm,
        tục tĩu hoặc phản cảm, hoặc vi phạm quyền sở hữu trí tuệ của bên thứ ba hoặc các điều khoản
        dịch vụ này.
      </Typography>
      <Typography variant="body2">
        Bạn đồng ý rằng chúng tôi có thể gửi thông báo cho bạn, bao gồm các thông báo liên quan đến
        các thay đổi về thỏa thuận, qua email, thư thông thường hoặc các bài đăng trên dịch vụ.
      </Typography>
      <Typography variant="body2">
        Bạn hiểu rằng việc xử lý và truyền dữ liệu kỹ thuật, bao gồm Nội dung của bạn, có thể được
        thực hiện mà không được mã hóa và có liên quan đến (a) việc truyền qua các mạng khác nhau;
        và (b) việc thay đổi để phù hợp và tương thích với yêu cầu kỹ thuật của mạng hoặc thiết bị
        kết nối. Bạn không được tải lên, đăng, lưu trữ hoặc truyền email, SMS hoặc bất kỳ hình thức
        gửi thư rác (spam) không mong muốn.
      </Typography>
      <Typography variant="body2">
        Bạn không được truyền bất kỳ loại sâu hoặc mã vi-rút, cũng như không được sử dụng bất kỳ mã
        nào có tính chất phá hoại.
      </Typography>
      <Typography variant="body2">
        Không có điều gì trong thỏa thuận này sẽ loại trừ hoặc hạn chế trách nhiệm của chúng tôi đối
        với thiệt hại không thể loại trừ hoặc hạn chế hợp pháp theo luật pháp của Cộng hòa Xã hội
        Chủ nghĩa Việt Nam.
      </Typography>
      <Typography variant="body2">
        Chúng tôi không thực hiện hoặc thực thi bất kỳ quyền hoặc điều khoản nào trong Thỏa thuận
        này sẽ không được coi là từ bỏ quyền hoặc điều khoản đó. Thỏa thuận này tạo thành toàn bộ
        thỏa thuận giữa bạn và chúng tôi trong việc điều chỉnh việc sử dụng dịch vụ, thay thế bất kỳ
        thỏa thuận trước đây (bao gồm, nhưng không giới hạn, bất kỳ phiên bản trước đây nào của thỏa
        thuận này).
      </Typography>
      <Typography variant="body2">
        Thỏa thuận này tuân thủ theo luật pháp của Cộng hòa Xã hội Chủ nghĩa Việt Nam.
      </Typography>
      <Typography variant="body2">
        Bất kỳ tranh chấp nào liên quan đến thỏa thuận sẽ được giải quyết thông qua đàm phán. Trường
        hợp không thể giải quyết tranh chấp bằng đàm phán, tranh chấp sẽ được xem xét tại Tòa án Tối
        cao Thành phố Hà Nội, Việt Nam.
      </Typography>
      <Typography variant="body2">
        Nếu bạn có bất kỳ câu hỏi nào về Điều khoản dịch vụ, vui lòng liên hệ với hỗ trợ tại
        centerup.vn.
      </Typography>
    </Stack>
  </PolicyTabLoyout>
);
